import { FC } from 'react';
import { useCourseReview } from '../../hooks/useCourseReview';
import { ReviewForm } from '@new/common/ui/ReviewForm/ReviewForm';
import { NotesHistory } from './NotesHistory';
import type {
  CourseReview as CourseReviewModel,
  Course,
  UserCourse,
  Note,
} from '@teachur/http-client';

interface CourseReviewProps {
  course: Course;
  userCourse: UserCourse;
  studentId: number;
  notes: Note[];
  reviews?: CourseReviewModel[];
  scheduledCallId: string;
}

export const CourseReview: FC<CourseReviewProps> = ({
  course,
  userCourse,
  studentId,
  notes,
  reviews = [],
  scheduledCallId,
}) => {
  const { handleSubmit } = useCourseReview({ course, userCourse, studentId, scheduledCallId });

  return (
    <div className="p-4 space-y-6 h-full flex flex-col gap-6">
      <div className="flex flex-col gap-2 m-0!">
        <h3 className="font-bold [font-size:var(--fs-h4)]! text-(--neutral-black-NB800)! m-0!">
          {course.name}
        </h3>
        <p className="text-(--neutral-black-NB800)! font-bold [font-family:var(--font-arvo)]! [font-size:var(--fs-l3)]! m-0!">
          Short Description
        </p>
        <p className="[font-size:var(--fs-p4)]! text-(--neutral-white-NW300) m-0!">
          {course.shortDescription || 'No description available'}
        </p>
      </div>

      <ReviewForm goals={course.goals ?? []} onSubmit={handleSubmit} />
      <NotesHistory notes={notes} reviews={reviews} />
    </div>
  );
};
